import { isSet, optionsToKeyValuePairs } from "../../../../../../utils/commonUtils";
import { computationRules1 } from "./DrugScreenCollection";
import { tbRiskQuestions, tbSymptomQuestions } from "./tbBloodQuestionnaire";

const stackedFieldStyle = {
  layout: 'stacked',
  showContainerBorder: false,
  labelWrap: false,
  isLabel: true,
};

// Chart config for TB Assessment
const tbAssessmentFormConfig = {
  type: 'Tab',
  col: 'col-md-9',
  data: [
    {
      id: 'History1',
      label: 'History',
      labelStyle: { padding: 0 },
      data: [
        {
          label: 'Tuberculosis Risk Questionnaire',
          hideHeader: true,
          cardBodyClassName: 'p-0',
          fields: [
            {
              type: 'NewYesOrNoFields',
              label: 'Tuberculosis Risk Questionnaire',
              col: 'col-12',
              options: [{ label: 'Yes', value: 1 }, { label: 'No', value: 0 }],
              defaultValues: tbRiskQuestions.reduce((acc, itm) => {
                acc[itm.name] = 0;
                return acc;
              }, {}),
              list: tbRiskQuestions
            }
          ]
        },
        {
          label: 'Tuberculosis Symptom Questionnaire',
          hideHeader: true,
          cardBodyClassName: 'p-0',
          fields: [
            {
              type: 'NewYesOrNoFields',
              label: 'Tuberculosis Symptom Questionnaire ',
              subLabel: 'Do you currently have any of the following symptoms?',
              sublabelStyle: 'text-left text-black text-md fw-bold opacity-100',
              col: 'col-12',
              options: [{ label: 'Yes', value: 1 }, { label: 'No', value: 0 }],
              defaultValues: tbSymptomQuestions.reduce((acc, itm) => {
                acc[itm.name] = 0;
                return acc;
              }, {}),
              list: tbSymptomQuestions
            }
          ]
        },
        {
          label: 'Patient Signature & Comments',
          labelStyle: "fw-semibold pl-2",
          col: 'col-12',
          fields: [
            {
              label: 'Comments',
              type: 'TextArea',
              name: 'tb_comments',
              id: 'tb_comments',
              col: 'col-md-6 col-12 border-0',
              layout: 'stacked',
              labelStyle: { paddingLeft: '0.75rem' },
              style: { minHeight: '150px', resize: 'vertical' },
              rows: 5,
              placeholder: "Content",
            },
            {
              label: "Signature",
              type: 'NewSignature',
              isLabel: false,
              col: 'col-md-6 col-12 border-0',
              name: 'tb_patient_signature',
              id: 'tb_patient_signature',
            },
          ]
        },
      ]
    },
    {
      id: 'Blooddraw',
      label: 'Blood draw',
      labelStyle: { padding: 0 },
      data: [
        {
          label: 'Blood Test',
          labelStyle: 'fw-semibold pl-2',
          fieldProps: stackedFieldStyle,
          fields: [
            {
              label: 'Collection Date',
              type: 'Date',
              name: 'blood_test_collection_date',
              id: 'blood_test_collection_date',
              className: "form-control form-control-solid",
              col: 'col-md-6 col-12',
              placeholder: 'MM / DD / YYYY',
              layout: 'stacked',
            },
            // {
            //   label: "Result",
            //   type: "Label",
            //   layout: 'stacked',
            //   col: 'col-12 border-0 ',
            //   name: "blood_test_result",
            //   id: 'blood_test_result',
            //   isBold:true,
            //   fontBold:'400',
            //   appendClassLabel:' text-md fw-semibold opacity-75',
            // },
            {
              type: 'radioBoxGroup',
              label: "Result",
              col: 'col-12 border-0 ',
              name: "blood_test_result",
              id: 'blood_test_result',
              isVertical: false ,
              isBold:true,
              fontBold:'400',
              isLabel:true,
              appendClassLabel:' text-md fw-semibold opacity-75',
              layout: 'stacked',
              combineToKey:"blood_test_result",
              options: [
                { value: 'blood_test_result_negative', label: 'Negative' },
                { value: 'blood_test_result_positive', label: 'Positive(Need Chest X-ray)' },
                { value: 'blood_test_result_indeterminate', label: 'Indeterminate(Need Chest X-ray)' },
              ]
            },
          ]
        },
        {
          label: 'Chest X-Ray',
          fieldProps: stackedFieldStyle,
          labelStyle: 'fw-semibold pl-2',
          fields: [
            {
              label: "PA View (min req)",
              type: "Label",
              layout: 'stacked',
              col: 'col-12 border-0 ',
              name: "supporting_observations",
              id: 'supporting_observations',
              isBold:true,
              fontBold:'400',
              appendClassLabel:'text-left text-black text-md fw-bold opacity-100',
            },
            {
              label: 'Date',
              type: 'Date',
              name: 'blood_chest_xray_date',
              id: 'blood_chest_xray_date',
              col: 'col-6',
              placeholder: 'MM / DD / YYYY',
              layout: 'stacked',
            },
            {
              type: 'radioBoxGroup',
              label: 'Result',
              layout: 'stacked',
              isVertical: false,
              col: 'col-6',
              showContainerBorder: false,
              name:"blood_chest_xray_result",
              id:"blood_chest_xray_result",
              combineToKey:"blood_chest_xray_result",
              options: [
                { value: 'blood_chest_xray_result_normal', label: 'Normal' },
                { value: 'blood_chest_xray_result_abnormal', label: 'Abnormal' },
              ],
            },
          ]
        },
        {
          label: 'Additional testing or follow up(Recommendations)',
          fieldProps: stackedFieldStyle,
          labelStyle: 'fw-semibold pl-2',
          fields: [
            {
              type: 'CheckBoxGroup',
              col: 'col-md-4',
              isLabel: false,
              isVertical: true,
              showContainerBorder: false,
              id:"blood_followup",
              name:"blood_followup",
              combineToKey:"blood_followup",
              options: [
                { name: 'blood_followup_repeat_skin_test', label: 'Repeat skin test' },
                { name: 'blood_followup_consult_infectious_disease', label: 'Consult infectious disease' },
                { name: 'blood_followup_followup_occ_health', label: 'AbFollow up occ health nursenormal' },
                { name: 'blood_followup_other', label: 'Other' },
              ]
            },
            {
              type: 'CheckBoxGroup',
              col: 'col-md-4',
              isLabel: false,
              isVertical: true,
              showContainerBorder: false,
              id:"blood_followup",
              name:"blood_followup",
              combineToKey:"blood_followup",
              options: [
                { name: 'blood_followup_chest_xray', label: 'Chest x-ray' },
                { name: 'blood_followup_start_prescription_treatment', label: 'Start prescription treatment' },
                { name: 'blood_followup_none', label: 'None' },
              ]
            },
            {
              type: 'CheckBoxGroup',
              col: 'col-md-4',
              isLabel: false,
              isVertical: true,
              showContainerBorder: false,
               id:"blood_followup",
              name:"blood_followup",
              combineToKey:"blood_followup",
              options: [
                { name: 'blood_followup_blood_test', label: 'Blood test' },
                { name: 'blood_followup_start_preventative_treatment', label: 'Start prescription treatment' },
              ]
            },
            {
              label: 'Content',
              type: 'TextArea',
              name: 'blood_followup_comment',
              id: 'blood_followup_comment',
              col: 'col-12',
              isLabel: false,
              placeholder: 'Content',
              rows: 3,
              disabled: true,
              rules: [
                { rule: [{ field: 'blood_followup', value: 'blood_followup_other', operator: 'includes' }], action: 'ENABLE' },
                // { rule: [{ field: 'blood_followup', value: 'blood_followup_other', operator: '!includes' }], action: 'CLEAR' }
              ],
            },
            
          ]
        },
        {
          label: 'Review / Completion',
          labelStyle: 'fw-semibold pl-2',
          fieldProps: stackedFieldStyle,
          fields: [
              {
                  type: 'ProviderSignOff',
                  col: 'col-12',
                  fields: [
                      { label: 'Signature PIN', name: 'provider_pin', col: 'col-12' },
                      { label: 'Signature', type: 'NewSignature', name: 'provider_signature', col: 'col-12' },
                      { label: 'Date', type: 'Date', name: 'signed_date', col: 'col-12' },
                      // { label: 'Suggested Result', placeholder: 'Not Started', type: 'TextInput', name: 'suggested_status', col: 'col-6' },
                      { label: 'Final Results', type: 'SelectList', name: 'status', statusBasedColor:true, col: 'col-12', options: [] },
                      { label: 'Activity Status', type: 'SelectList', name: 'activity_status',  statusBasedColor:true, col: 'col-12', options: [] },
                  ],
              },
          ],
      },
      ]
    },
  ]
};

const TBBloodAssessment = (props) => {
  const tabData = JSON.parse(JSON.stringify(tbAssessmentFormConfig));
  
  // Update status dropdowns in Review/Completion section for both tabs
  const tabsToUpdate = ['Blooddraw', 'SkinTest'];
  tabsToUpdate.forEach(tabId => {
    const tab = tabData.data.find((t) => t.id === tabId);
    if (tab && tab.data) {
      const reviewSection = tab.data.find((s) => s.label === 'Review / Completion');
      if (reviewSection && reviewSection.fields && reviewSection.fields[0] && reviewSection.fields[0].fields) {
        const providerFields = reviewSection.fields[0].fields;
        const statusField = providerFields.find((f) => f.name === 'status');
        const activityStatusField = providerFields.find((f) => f.name === 'activity_status');

        // Previous options:
        // if (statusField) statusField.options = isSet(props.lookupsOptions?.['chartResult'], []);
        // if (activityStatusField) activityStatusField.options = optionsToKeyValuePairs(['Not Started', 'Ordered', 'Completed', 'Cancelled'],false);

        // New standard options:
        if (statusField) {
          statusField.options = optionsToKeyValuePairs(
            [
              "Not Started",
              "Pending",
              "Normal",
              "Abnormal",
              "Negative",
              "Positive",
              "Dispensed",
              "Administered",
              "Failed",
              "Passed",
              "Non-Negative",
              "Cancelled",
              "Inconclusive",
            ],
            false
          );
        }
        if (activityStatusField) {
          activityStatusField.options = optionsToKeyValuePairs(
            [
              "Not Started",
              "Pending",
              "Pending Lab Confirmation",
              "Pending MRO Confirmation",
              "Ready for Review",
              "Completed",
              "Cancelled",
            ],
            false
          );
        }
      }
    }
  });

  const charts = [
    {
      type: 'Grid',
      col: 'col-md-3',
      data: [
        { type: 'PatientDetails', employeeDetails: props.employeeDetails, visitDetails: props.visitDetails },
        { type: 'CompanyDetails', companyDetails: props.companyDetails },
      ],
    },
    tabData,
  ];

  const defaultValue = {
    // ...tbRiskQuestions.reduce((acc, itm) => {
    //   acc[itm.name] = 0;
    //   return acc;
    // }, {}),
    // ...tbSymptomQuestions.reduce((acc, itm) => {
    //   acc[itm.name] = 0;
    //   return acc;
    // }, {}),
    status: 'Not Started',
    activity_status: 'Not Started',
  };

  const headers = [];

  return {
    charts,
    defaultValue,
    headers,
    computationFunction: (formData, key) => computationRules1(formData, key),
    buttons: {
      PDF: true,
    },
  };
};

export default TBBloodAssessment;
